import { defineStore } from 'pinia'

import { ref } from 'vue'

export const useWorkflowReviewFocus = defineStore(
  'workflow-review-focus',
  () => {
    const nextReviewItemIndexToFocus = ref<number | null>(null)

    function completeNextReviewItemFocus(): void {
      nextReviewItemIndexToFocus.value = null
    }

    function triggerNextReviewItemFocus(index: number): void {
      nextReviewItemIndexToFocus.value = index
    }

    return {
      nextReviewItemIndexToFocus,
      completeNextReviewItemFocus,
      triggerNextReviewItemFocus,
    }
  }
)
